import { AppNames } from '@shared/types'

import { lazy } from 'react'

import { useMenuItems, useSelectedMenuItems } from './hooks'

const AppRouter = lazy(() => import('./AppRouter'))

export const useCmsConfig = () => {
  const menuItems = useMenuItems()
  const selected = useSelectedMenuItems()

  return {
    key: AppNames.Cms,
    path: '/apps/cms/:token/*',
    menu: menuItems,
    selectedKeys: [selected],
    routes: <AppRouter />
  }
}
